import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-ocean-service',
    templateUrl: './ocean-service.component.html',
    styleUrls: ['./ocean-service.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OceanServiceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
